module.exports = __webpack_public_path__ + "files/58e206867f44d7efe690bceefcc82b8f.png";